module.exports = __webpack_public_path__ + "/assets/ajax-loader.2955bc55df089f470b8f80ddfc9a8ae1.gif";